import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient , HttpParams} from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: ['./payment-form.component.scss']
})
export class PaymentFormComponent implements OnInit {

  constructor(public fb: FormBuilder, private http: HttpClient, private _router: Router) { }

  ngOnInit(): void {

  this.http.get('https://ghrscf.com/includes/view-summer-camp.php').subscribe(
      (response) => console.log(response),
     (error) => console.log(error)
   );
  }

}
